// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --primary: #66D2CE;
    --secondary: #2DAA9E;
    --light: #EAEAEA;
    --beige: #E3D2C3;
    --white: #FFFFFF;
    --black: #000000;
    --error: #EF4444;
}

/* Footer.css */
.footer {
    background-color: var(--secondary);
    padding: 4rem 0;
    color: var(--white);
}

.footer-container {
    max-width: 80rem;
    margin: 0 auto;
    padding: 0 1rem;
}

.footer-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 2rem;
}

.footer-column {
    display: flex;
    flex-direction: column;
}

.footer-heading {
    font-size: 1.25rem;
    font-weight: 700;
    color: var(--white);
    margin-bottom: 1rem;
}

.footer-links {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
}

.footer-link {
    color: var(--light);
    text-decoration: none;
    transition: color 0.2s;
}

.footer-link:hover {
    color: var(--white);
}

.contact-info {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.address {
    color: var(--light);
    line-height: 1.5;
}

.contact-item {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
    color: var(--light);
}

@media (min-width: 768px) {
    .footer-grid {
        grid-template-columns: repeat(3, 1fr);
    }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Footer.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,eAAe;AACf;IACI,kCAAkC;IAClC,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,0BAA0B;IAC1B,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ","sourcesContent":[":root {\n    --primary: #66D2CE;\n    --secondary: #2DAA9E;\n    --light: #EAEAEA;\n    --beige: #E3D2C3;\n    --white: #FFFFFF;\n    --black: #000000;\n    --error: #EF4444;\n}\n\n/* Footer.css */\n.footer {\n    background-color: var(--secondary);\n    padding: 4rem 0;\n    color: var(--white);\n}\n\n.footer-container {\n    max-width: 80rem;\n    margin: 0 auto;\n    padding: 0 1rem;\n}\n\n.footer-grid {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 2rem;\n}\n\n.footer-column {\n    display: flex;\n    flex-direction: column;\n}\n\n.footer-heading {\n    font-size: 1.25rem;\n    font-weight: 700;\n    color: var(--white);\n    margin-bottom: 1rem;\n}\n\n.footer-links {\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n}\n\n.footer-link {\n    color: var(--light);\n    text-decoration: none;\n    transition: color 0.2s;\n}\n\n.footer-link:hover {\n    color: var(--white);\n}\n\n.contact-info {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n}\n\n.address {\n    color: var(--light);\n    line-height: 1.5;\n}\n\n.contact-item {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 0.5rem;\n    color: var(--light);\n}\n\n@media (min-width: 768px) {\n    .footer-grid {\n        grid-template-columns: repeat(3, 1fr);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
